import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { GetDetails } from "../actions";
import { GET_TOKEN, SIGNOUT } from "../actions/types";

function TransparentLoginBootstrap() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const accessToken = searchParams.get("uta");
    const refreshToken = searchParams.get("utr");
    const redirectLink = searchParams.get("link") || "/";

    if (!accessToken || !refreshToken) {
      return;
    }

    localStorage.removeItem("pending_atoken");
    localStorage.removeItem("pending_rtoken");
    localStorage.setItem("atoken", accessToken);
    localStorage.setItem("rtoken", refreshToken);

    dispatch({ type: SIGNOUT });
    dispatch({
      type: GET_TOKEN,
      payload: {
        access: accessToken,
        refresh: refreshToken,
      },
    });

    dispatch(GetDetails((destination, options) => navigate(destination, options), { from: redirectLink }));
  }, [dispatch, location.search, navigate]);

  return null;
}

export default TransparentLoginBootstrap;
